import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from '@/components/Sidebar';
import Topbar from '@/components/Topbar';
import { getDefaultPath } from '@/helpers/url_sync';

function AuthLayout({ children }) {
    const location = useLocation();

    const [collapsed, setCollapsed] = useState(true);
    const [openKeys, setOpenKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState(getDefaultPath());

    useEffect(() => {
        if (!collapsed) {
            setOpenKeys(getDefaultPath());
        }
        setSelectedKeys(getDefaultPath());
    }, [collapsed, location]);

    return (
        <Layout>
            <Sidebar
                collapsed={collapsed}
                openKeys={openKeys}
                setOpenKeys={setOpenKeys}
                selectedKeys={selectedKeys}
                setSelectedKeys={setSelectedKeys}
            />
            <Layout className={`${!collapsed && 'sidebar-opened'}`}>
                <Topbar
                    collapsed={collapsed}
                    setCollapsed={setCollapsed}
                    setSelectedKeys={setSelectedKeys}
                    selectedKeys={getDefaultPath()}
                />
                <Layout.Content
                    style={{
                        margin: '24px 16px',
                        padding: 24,
                        minHeight: 280,
                    }}
                >
                    {children}
                </Layout.Content>
            </Layout>
        </Layout>
    );
}

export default AuthLayout;
